import { render, staticRenderFns } from "./OperationLogsCSV.vue?vue&type=template&id=8a8fc224&"
import script from "./OperationLogsCSV.vue?vue&type=script&lang=ts&"
export * from "./OperationLogsCSV.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports